var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import translations from './translations';
import css from './style.pcss';
import * as dayjs from "dayjs";
var RTLSportHeader = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportHeader, _LitElement);
  function RTLSportHeader() {
    var _this;
    _classCallCheck(this, RTLSportHeader);
    _this = _callSuper(this, RTLSportHeader);
    _this.language = 'lu';
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 15000);
    _this.view = 'default';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.version = window.rtlsites.config.version;
    }
    return _this;
  }
  _createClass(RTLSportHeader, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportHeader.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var _apiUrl = `https://api-gate.rtl.lu/sport/matches/${this.match}?lang=${this.language}`;
      fetch(_apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        //console.log(this.data);
        _this2.view = 'default';
      }).catch(function (error) {
        if (this.interval) clearInterval(this.interval);
        console.log('ERROR: ' + error.message);
      }.bind(this));
    }
  }, {
    key: "_showTeam",
    value: function _showTeam(teamId) {
      // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
      var sportSlug;
      switch (this.sport) {
        case 1:
          sportSlug = "futtball";
          break;
        case 2:
          sportSlug = "basketball";
          break;
        case 3:
          sportSlug = "handball";
          break;
        case 4:
          sportSlug = "volleyball";
          break;
        case 5:
          sportSlug = "deschtennis";
          break;
      }
      var hlslug = '/resultats';
      if (this.language === 'en') hlslug = '/results';
      if (this.language === 'lu') hlslug = '/' + sportSlug + '/resultater';
      window.open(`/sport${hlslug}/teams?t=${teamId}&c=${this.competition}&season=${this.data.competition.season_id}`, '_blank');
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      var _this3 = this;
      var sets = [];
      if (this.data.sets) {
        this.data.sets.map(function (set) {
          sets.push(html(_t || (_t = _`
                                <span>${0}:${0}</span>
                            `), set[0], set[1]));
        });
      }
      return html(_t2 || (_t2 = _`
            <div class="liveticker-teams__score-header">
                <div class="liveticker-teams">
                    <div class="liveticker-teams__team liveticker-teams__team--first">
                        ${0}
                        <div class="liveticker-teams__team-title liveticker-teams__team-title--position" @click=${0}>${0}</div>
                    </div>

                    <div class="liveticker-score">
                        ${0}
                        ${0}

                        ${0}
                    </div>

                    <div class="liveticker-teams__team liveticker-teams__team--seconde">
                        <div class="liveticker-teams__team-title" @click=${0}>${0}</div>
                        ${0}
                    </div>

                </div>
                <div class="liveticker-teams__separator">
                    <div class="liveticker-teams__separator-line line-mrg"></div>
                    ${0}
                    <div class="liveticker-teams__separator-line line-mrg--right"></div>
                </div>
            </div>
        `), this.data.home_team.logo_url ? html(_t3 || (_t3 = _`<div class="liveticker-teams__team-img-container" @click=${0}><img class="liveticker-teams__team-img" src="${0}?v=${0}"></div>`), function (e) {
        return _this3._showTeam(_this3.data.home_team.id);
      }, this.data.home_team.logo_url, this.version) : '', function (e) {
        return _this3._showTeam(_this3.data.home_team.id);
      }, this.data.home_team.name, this.data.home_score !== '-' && this.data.visitor_score !== '' ? html(_t4 || (_t4 = _`
                                ${0}  :  ${0}
                        `), this.data.home_score, this.data.visitor_score) : `VS`, sets.length > 0 ? html(_t5 || (_t5 = _`<small class="liveticker-sets">${0}</small>`), sets) : '', this.data.hour && html(_t6 || (_t6 = _`<p class="liveticker-teams__time">${0} ${0}</p>`), dayjs(this.data.date).format('DD/MM/YYYY'), this.data.hour), function (e) {
        return _this3._showTeam(_this3.data.visitor_team.id);
      }, this.data.visitor_team.name, this.data.visitor_team.logo_url ? html(_t7 || (_t7 = _`<div class="liveticker-teams__team-img-container" @click=${0}><img class="liveticker-teams__team-img" src="${0}?v=${0}"></div>`), function (e) {
        return _this3._showTeam(_this3.data.visitor_team.id);
      }, this.data.visitor_team.logo_url, this.version) : '', this.data.hour && html(_t8 || (_t8 = _`<p class="liveticker-teams__bottom">${0}</p>`), this.data.competition.name));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data === undefined) return html(_t9 || (_t9 = _`Loading...`));
      return html(_t10 || (_t10 = _`
            <style>${0}</style>
            ${0}
        `), css, this._renderDefault());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        sport: {
          type: Number
        },
        // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
        competition: {
          type: Number
        },
        match: {
          type: Number
        },
        language: {
          type: String
        },
        view: {
          type: String
        }
      };
    }
  }]);
  return RTLSportHeader;
}(LitElement);
export { RTLSportHeader as default };
window.customElements.define('rtl-sport-header', RTLSportHeader);